import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AufgabeAdmin } from "@reflact/ipkv-types";
import { firstValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AufgabenService {
  public aufgaben: AufgabeAdmin[] = [];
  public selectedAufgabe: AufgabeAdmin = { _id: '', aufgabenIndex: 0, createdAt: '', einleitung: '', fallaufgabenId: '', updatedAt: '', title: '' };
  private http = inject(HttpClient);
  private baseRoute = "/api/admin/aufgabe";

  public async create(createOpts: { einleitung: string, aufgabenIndex: number, fallaufgabenId: string, title: string }) {
    const createResult = await firstValueFrom(this.http.post<AufgabeAdmin>(this.baseRoute + "/create", createOpts));
    this.aufgaben.push(createResult);
    return createResult._id;
  }

  public async update() {
    const updateResult = await firstValueFrom(this.http.post<AufgabeAdmin>(this.baseRoute + "/update", this.selectedAufgabe));
    const index = this.aufgaben.findIndex((a) => a._id === updateResult._id);
    if (index >= 0 && this.aufgaben[index]) this.aufgaben[index] = updateResult;
    if (updateResult._id === this.selectedAufgabe._id) this.selectedAufgabe = updateResult;
  }


  public async reorder(reorderOpts: { fallaufgabenId: string, dragIndex: number, dropIndex: number }) {
    const data = await firstValueFrom(this.http.post<AufgabeAdmin[]>(this.baseRoute + "/reorder", reorderOpts));
    this.sort(data);
  }

  public async delete(_id: string, fallaufgabenId: string) {
    const data = await firstValueFrom(this.http.post<AufgabeAdmin[]>(this.baseRoute + "/delete", { _id, fallaufgabenId }));
    this.sort(data);
  }

  public set(id: string) {
    const aufgabe = this.aufgaben.find(a => a._id === id);
    if (aufgabe) this.selectedAufgabe = aufgabe;
  }

  public reset() {
    this.selectedAufgabe = { _id: '', aufgabenIndex: 0, createdAt: '', einleitung: '', fallaufgabenId: '', updatedAt: '', title: '' };
  }

  public sort(data: AufgabeAdmin[]) {
    this.aufgaben = data.sort((a, b) => {
      if (a.aufgabenIndex < b.aufgabenIndex) return -1;
      if (a.aufgabenIndex > b.aufgabenIndex) return 1;
      return 0;
    });
  }

  public getAufgabeById(aufgabenId: string) {
    return this.aufgaben.find(a => a._id == aufgabenId)
  }
}
